import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MessageService, ConfirmationService } from 'primeng/api';
import { HttpCallHandleService } from './helper/Interceptor/http-call-handle.service';
import { AuthService } from './helper/service/auth.service';

import { routes } from './app.routes';
import { JWTInterceptor } from './helper/Interceptor/jwt.interceptor';
import { ErrorInterceptor, SuccessInterceptor } from './helper/Interceptor/error.interceptor';
import { SettingsService } from './helper/service/settings.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(ModalModule.forRoot()),
    MessageService,
    ConfirmationService,
    HttpCallHandleService,
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SuccessInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (s: SettingsService) => () => s.init().toPromise(),
      deps: [SettingsService],
      multi: true,
    },
  ]
};
